export const INFO_TEXTAREA_ROWS = 8;

export const AMOUNT_OF_DELIVERY_DATES_TO_SHOW = 20;
